import Api from './Api';

const downloadSalesBySitesAsPdf = (payload) => {
    const path = '/invoice/sales-report-by-site-as-pdf';
    const endpoint = payload ? `${path + '?' + Object.keys(payload).map(key => key + '=' + payload[key]).join('&')}` : path;

    return Api.getRequestBlob({
        endpoint
    });
};

export default {
    downloadSalesBySitesAsPdf,
};
